import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Check, ShieldCheck, Headphones, Lock } from 'lucide-react';
export function CtaSection() {
  return <section id="pricing" className="py-24 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-charcoal-dark to-charcoal relative" data-id="element-39">
      <div className="max-w-3xl mx-auto text-center" data-id="element-40">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="space-y-10" data-id="element-41">
          {/* Headline */}
          <div data-id="element-42">
            <h2 className="text-4xl sm:text-5xl md:text-6xl font-bold leading-tight mb-6" data-id="element-43">
              Estás a un{' '}
              <span className="text-gold italic font-normal" data-id="element-44">paso</span>
            </h2>

            {/* Trust Bullets */}
            <ul className="flex flex-col sm:flex-row justify-center items-center gap-4 sm:gap-8 mb-6" data-id="element-45">
              {['Acceso inmediato', 'No necesitás experiencia', 'Podés empezar hoy mismo'].map((bullet, i) => <li key={i} className="flex items-center gap-2 text-lg text-cream" data-id="element-46">
                  <Check className="w-5 h-5 text-gold flex-shrink-0" strokeWidth={3} data-id="element-47" />
                  <span className="font-medium" data-id="element-48">{bullet}</span>
                </li>)}
            </ul>

            {/* Trust Text */}
            <p className="text-cream-muted text-lg" data-id="element-49">
              Compra rápida y segura. Recibís todo en tu mail en minutos.
            </p>
          </div>

          {/* Main Pricing Card */}
          <div className="bg-warmBrown border border-gold/30 rounded-3xl p-6 sm:p-10 lg:p-12 relative overflow-hidden shadow-[0_0_50px_rgba(212,168,83,0.15)]" data-id="element-50">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-32 bg-gold/20 blur-[60px] pointer-events-none" data-id="element-51" />

            {/* Product Image */}
            <img src="https://cdn.magicpatterns.com/uploads/jdVrssbjQjGtppE5kJgSN1/ChatGPT_Image_4_abr_2026,_11_07_59_p.m..png" alt="Pack completo" className="max-w-[280px] sm:max-w-sm mx-auto mb-8 drop-shadow-[0_20px_30px_rgba(0,0,0,0.5)] relative z-10" data-id="element-52" />

            {/* Urgency */}
            <div className="inline-block bg-red-500/10 border border-red-500/20 rounded-full px-4 py-2 mb-6" data-id="element-53">
              <p className="text-sm sm:text-base font-semibold text-red-400 flex items-center justify-center gap-2" data-id="element-54">
                <span data-id="element-55">🔥</span> Hoy precio lanzamiento. Mañana aumenta.
              </p>
            </div>

            {/* Price */}
            <div className="flex flex-col items-center justify-center mb-8" data-id="element-56">
              <div className="flex items-baseline gap-3 mb-1" data-id="element-57">
                <span className="text-6xl sm:text-7xl font-bold text-gold tracking-tight" data-id="element-58">
                  $14.990
                </span>
                <span className="text-2xl text-gold/80 font-medium" data-id="element-59">ARS</span>
              </div>
              <p className="text-lg text-cream-muted/50 line-through" data-id="element-60">
                Antes $29.980
              </p>
            </div>

            {/* Guarantee Highlight */}
            <div className="bg-charcoal/50 border border-gold/20 rounded-2xl p-5 mb-8 max-w-lg mx-auto flex items-start gap-4 text-left" data-id="element-61">
              <div className="bg-gold/10 p-3 rounded-full flex-shrink-0" data-id="element-62">
                <ShieldCheck className="w-6 h-6 text-gold" data-id="element-63" />
              </div>
              <div data-id="element-64">
                <h4 className="font-bold text-cream mb-1" data-id="element-65">
                  Garantía de 7 días
                </h4>
                <p className="text-sm text-cream-muted leading-relaxed" data-id="element-66">
                  Probalo 7 días. Si no te sirve, te devolvemos el dinero. Sin
                  preguntas.
                </p>
              </div>
            </div>

            {/* CTA Button */}
            <motion.a href="https://lacocinaquevende.shop/cart/53378602205457:1" whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="w-full sm:w-auto min-w-[300px] group relative inline-flex items-center justify-center gap-3 px-8 py-5 text-xl font-bold text-charcoal bg-gold hover:bg-gold-light rounded-full overflow-hidden transition-all duration-300 shadow-[0_0_40px_rgba(212,168,83,0.4)] hover:shadow-[0_0_60px_rgba(212,168,83,0.6)] mb-4" data-id="element-67">
              <span className="relative z-10 flex items-center gap-2" data-id="element-68">
                QUIERO EMPEZAR HOY
                <ArrowRight className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-69" />
              </span>
              <div className="absolute inset-0 h-full w-full bg-gradient-to-r from-transparent via-white/30 to-transparent -translate-x-full group-hover:animate-[shimmer_1.5s_infinite]" data-id="element-70" />
            </motion.a>

            {/* Privacy Microcopy */}
            <div className="flex items-center justify-center gap-2 text-[13px] text-cream-muted/60 max-w-md mx-auto mb-10" data-id="element-71">
              <Lock className="w-4 h-4 flex-shrink-0" data-id="element-72" />
              <p data-id="element-73">
                Completá rápido. Solo usamos estos datos para procesar tu
                compra. No compartimos tu información.
              </p>
            </div>

            {/* Payment Methods */}
            <div className="flex flex-col items-center gap-4 mb-8" data-id="element-74">
              <img src="https://cdn.magicpatterns.com/uploads/skrFUyqtUJTwMzj9hzFaaf/descarga_(2).png" alt="Mercado Pago" className="w-[140px] h-auto" data-id="element-75" />
              <p className="text-sm text-cream-muted/80 font-medium" data-id="element-76">
                Hasta 3 cuotas sin interés con tarjeta
              </p>
              <div className="flex items-center gap-3" data-id="element-77">
                <span className="bg-[#1a1f71] text-white px-3 py-1.5 rounded text-xs font-bold italic" data-id="element-78">
                  VISA
                </span>
                <span className="bg-[#eb001b] text-white px-3 py-1.5 rounded text-xs font-bold italic" data-id="element-79">
                  mastercard
                </span>
              </div>
            </div>

            {/* Trust Badges */}
            <div className="flex flex-wrap justify-center gap-x-6 gap-y-4 text-sm text-cream-muted/80 border-t border-white/10 pt-8" data-id="element-80">
              <span className="flex items-center gap-2" data-id="element-81">
                <Check className="w-4 h-4 text-gold" strokeWidth={3} data-id="element-82" />
                Acceso inmediato
              </span>
              <span className="flex items-center gap-2" data-id="element-83">
                <ShieldCheck className="w-4 h-4 text-gold" data-id="element-84" />
                Pago seguro
              </span>
              <span className="flex items-center gap-2" data-id="element-85">
                <Headphones className="w-4 h-4 text-gold" data-id="element-86" />
                Soporte incluido
              </span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}